const borderOrder = ['top', 'right', 'bottom', 'left'] as const;

interface ElementSize {
  height: number;
  width: number;
}

type Borders = Record<(typeof borderOrder)[number], boolean>;

export const getStrokeDasharray = (
  elementSize: ElementSize,
  borders: Borders,
) => {
  const elementArea = {
    top: elementSize.width,
    right: elementSize.height,
    bottom: elementSize.width,
    left: elementSize.height,
  };

  const dashArray: number[] = [];

  let lastSide = -1;

  for (const side of borderOrder) {
    if (lastSide !== +borders[side]) {
      if (side === 'top' && !borders[side]) {
        // Start with 0 so we can gap the top
        dashArray.push(0);
      }

      // Start a line or a gap
      dashArray.push(elementArea[side]);
    } else {
      // Continue the last line or gap
      dashArray[dashArray.length - 1] += elementArea[side];
    }
    lastSide = +borders[side];
  }

  return dashArray.join(',');
};
